
import { jsPDF } from 'jspdf';

import { getMultiSceneCoreViewer } from '../../multiscene/components/MultiSceneBase';

const getMapContent = () => {
    let content = null;
    let nodes = document.querySelectorAll('.ol-layer canvas');
    if (nodes.length > 0) {
        let canvas = nodes[0];
        const { width, height } = canvas.getBoundingClientRect();
        content = {
            width,
            height,
            content: canvas.toDataURL()
        };
    }

    return content;
}

const getMultiSceneContent = () => {
    let content = null;
    let viewer = getMultiSceneCoreViewer();
    if (viewer) {
        content = viewer.getActualDimensionScene().getCanvasContent();
    }
    return content;
}

const getPageOptions = (orientation) => {
    return {
        orientation: orientation,
        unit: 'mm',
        format: 'a4'
    };
}

const getPage = (options) => {
    const LANDSCAPE = {
        orientation: 'l',
        maxWidth: 270,
        maxHeight: 195,
        marginX: 10,
        marginY: 10
    };
    const PORTRAIT = {
        orientation: 'p',
        maxWidth: 190,
        maxHeight: 270,
        marginX: 10,
        marginY: 10
    }
    return ((options.orientation || 'p') === 'l')
        ? LANDSCAPE
        : PORTRAIT;
}

const addImageToDoc = (doc, imageContent, page) => {

    let y = 15;

    let width = page.maxWidth;
    let imageMaxHeight = page.maxHeight - y;
    let height = width * imageContent.height / imageContent.width;
    if (height > imageMaxHeight) {
        width = width * imageMaxHeight / height;
        height = imageMaxHeight;
    }

    let x = page.marginX + (page.maxWidth - width) / 2;

    doc.addImage(
        imageContent.content, 'PNG', x, y, width, height
    );
}

const generatePdf = (options) => {
    options = options || {};
    let page = getPage(options);
    let doc = new jsPDF(getPageOptions(page.orientation));

    let needAddPage = false;

    if (options.title) {
        doc.text(
            options.title,
            (page.marginX + page.maxWidth + page.marginX) / 2,
            page.marginY,
            {align: 'center'}
        );
    }

    if (options.printMap) {
        let content = getMapContent();
        if (content) {
            addImageToDoc(doc, content, page);
            needAddPage = true;
        }
    }

    if (options.printMultiScene) {
        let content = getMultiSceneContent();
        if (content) {
            if (needAddPage) {
                doc.addPage(getPageOptions(page.orientation));
            }
            addImageToDoc(doc, content, page);
        }
    }

    return doc;
}

export default generatePdf;
